export const NEED_LOGIN_ROUTERS = [
  '/myPaper',
  '/browserHistory',
]